<template>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M16.2342 2.41311C16.5917 2.77061 16.5917 3.34811 16.2342 3.70561L14.5567 5.38311L11.1192 1.94561L12.7967 0.268117C12.968 0.096464 13.2005 0 13.443 0C13.6855 0 13.918 0.096464 14.0892 0.268117L16.2342 2.41311ZM0 16.044V13.2573C0 13.129 0.045834 13.019 0.1375 12.9273L10.1384 2.92648L13.5759 6.36398L3.56584 16.3648C3.48334 16.4565 3.36417 16.5023 3.245 16.5023H0.458337C0.201667 16.5023 0 16.3007 0 16.044Z" fill="#A6AAB4"></path>
</template>

<script>
    export default {
        name: 'icon-pencil'
    }
</script>